'use strict';

module.exports = {
  template: require('./update.html'),
  controller: require('./update.controller'),
  controllerAs: 'vm',

  bindings: {
    id: '<',
    me: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/update/index.js
 ** module id = 156
 ** module chunks = 0
 **/